<template>
  <div class="PF001 mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/PF001"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <a download=""></a>
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.navSixteenth')}}</h1>
                <div class="machineSeach">
                  <label style="margin-right:10px;font-size:12px;">{{$t('SingleTireStepAnalysis.labelTitle')}}</label>
                  <!-- <el-cascader
                    class="idStyle"
                    @change="getShiftTime(machineID)"
                    :placeholder="$t('SingleTireStepAnalysis.placehoder1')"
                    expand-trigger="hover"
                    :options="options"
                    filterable
                    v-model="machineID">
                  </el-cascader> -->
                  <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
                </div>
              </div>
              <!-- 页面主体部分-->
              <div class="my">
                <div class="mynavlist">
                    <div class="navlistleft">
                        <!-- date 选择日期 -->
                        <div class="searchnavdate">
                        <div class="block">
                            <el-date-picker 
                            v-model="datevalue"
                            type="date"
                            :placeholder="$t('AnalogValueAnalysis.Choosedate')"
                            :picker-options="pickerOptions"
                            @change="kongdata(datevalue)"
                            >
                            </el-date-picker>
                        </div>
                        </div>
                        <!-- time 选择时间 -->
                        <div class="searchnavtime">

                            <el-time-select
                              v-model="timevalueS"
                              :picker-options="nowTimeS()"
                              :placeholder="$t('AnalogValueAnalysis.Choosetime')"
                              @change="kongtime(timevalueS)">
                            </el-time-select>

                        </div>
                        <div class="addEight"> + 8 {{$t('PF001.hours')}}</div>
                    </div>  
                    <div class="navlistright">
                        <el-button type="primary" class="searchstart" icon="el-icon-view" @click="searchstart">{{$t('PF001.show')}}</el-button>
                    </div>
                </div>
                <!-- <div class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentData')}}</div> -->
                <div class="importantbody" v-show="importantbody">
                  <div class="selectsort" v-show="islangChange==1">{{machineName}}的产能预测</div>
                  <div class="selectsort" v-show="islangChange==0">Productivity Forecast of {{machineName}}</div>
                  <div class="selecttime">
                    <span>{{datevalue1.dateStart}}</span><span class="blank">{{timevalue1.timeStart}}</span>
                    <span>{{datevalue1.dateEnd}}</span><span class="blank">{{timevalue1.timeEnd}}</span>
                  </div>
                  <!-- echarts图表 -->
                  <div id="myecharts" v-loading="myecharts"></div>
                </div>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"
export default {
  name: 'PF001',
  components: {
    leftNav,
    equipment
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      fullscreenLoading: false,
      //我的代码
      
       pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
       },
      datevalue:'',//日期
      timevalueS:'',//时间
      datevalue1:{
        dateStart:'',
        dateEnd:'',
        date:''
      },
      timevalue1:{
        timeStart:'',
        timeEnd:'',
        hours:'',
        time:''
      },
      machineName:'',
      myecharts:false,//echarts图表
      importantbody:false,
      tbmid:'',
      echartsXList :[],
      actualList:[],//实际值
      predictedList:[],//预测值
      today:'',
      downImg:false,
      downExcel:false
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
    datevalue(){
      this.datevaluechange()
      this.correctionTime()
    },
    timevalueS(){
      this.timevalueSchange()
      this.datevaluechange()
      this.nowTimeS()
    }
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    this.getManiceList()
    this.initChart()
  },
  destroyed() {
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[0]=Number(this.$store.state.defaultFactoryId)
      this.machineID[1]=value
      this.getShiftTime(this.machineID)
    },
    // 获取车间列表
    getManiceList() {

      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(localStorage.getItem('isMarketAccount') === '1') {
            _this.$store.commit('marketAccount',res.data.options)
          }
          _this.options = res.data.options
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    getShiftTime(x){//动态绑定EventCode
      this.tbmid = x[1]
      let a = x[0]
      let arra = this.options.filter((item)=>{
        return item.value == a
      })
      let childrenarr = arra[0].children
      let brrb = childrenarr.filter((item)=>{
        return item.value == x[1]
      })
      this.machineName = brrb[0].label
    },
    //我的代码
    initChart(){
      let _this = this
        let myChart = this.$echarts.init(document.getElementById('myecharts'));
        myChart.setOption({
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#283b56'
                }
            },
            formatter:function(msg){//msg[0]预测值 msg[1]实际值

              if(msg.length === 1){
                
                return msg[0].axisValue +'<br/>'+msg[0].marker + msg[0].seriesName + ': '+msg[0].value
              }else if(msg.length === 2){

                return msg[0].axisValue +'<br/>'+msg[0].marker + msg[0].seriesName + ': '+msg[0].value+'<br/>' + msg[1].marker + msg[1].seriesName +': '+ msg[1].value
              }
            }
        },
        legend: {
            data:[_this.$t('PF001.predicted'), _this.$t('PF001.actual')]
        },
        toolbox: {
          show: true,
          itemSize:30,
          // top:'-3%',
          feature: {
            // echart下载成图片
            saveAsImage: {
              show:_this.downImg,
              title:' ',
              icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUVGMkVDN0U0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUVGMkVDN0Q0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBmNjIyOWI0LWJkNDItZGM0YS1iNDljLTIyZTFiYTgwNzZhYSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7PlZeJAAAAM1BMVEX////h4eEoJib8/Pzj4+OysbHu7u75+flLSkr+/v5+fn7d3d3MzMzq6urp6env7++VlZXRcGIdAAAAZ0lEQVR42tyTSw6AIAwFH6WtogLe/7SaGDeghY2JOutJm34egrIzYA3Q5GHgUwabxu4wHBq4byvDRETyBmWlk+W2ihzCOBuNpDLqvUhpXKxOCuORA/QM/Yuv64iaRjuwMaMd+02AAQA9ewKBbQnBzgAAAABJRU5ErkJggg=='
            },
            // 下载数据
            myTool2:{
              show: _this.$store.state.authority.PageDownload.show && _this.downExcel,
              // show: true,
              title:' ',
                icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3OUE4Mzk1ODYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3OUE4Mzk1OTYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjc5QTgzOTU2NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjc5QTgzOTU3NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+dmf26AAAAWpJREFUeNpivHfvHhsDA0M3EMcAsRADfcF7IF4MxKUsQKKLk5MzT1RUlIGZmZmurvj796/g69ev874DAROQHzsQjgABkJ0gu4EgFeQQoYFwBLJjQG5gYhgkgIUYRVdvPmZYvngmw+fPn/GqMzc3Z4iKiiLLIUSFCDGOAIGTJ08yLFu2jHYhAnPExIkTcarJz8+HOwYESA0ZmqQRckKGZomVVMfQNNeQ4hiaZ19YmqFKYiUGYEvIsAQ8KEJkyDmEoqjZuWMHw7bt28FsL09PBncPj6EfIkM7as6dO8ewcOFCFDFQFIEwuRUfWSFiZGTEEB8fT//alxjHUOIIinMNyDEgcOPGDYocQZWSFeQYmINo7hBeXl5wm4SUIhsG5OXkqJdGgoKCiDYQ3QMOjo7UCxFqBf+QKVnfAXtcA+YAqN3vQA5Z/ObNG4aBcMyfP38YQHYDwRxQGin79u0b46NHj2KBbMEB6oTXAgQYAEk/geeSh3YUAAAAAElFTkSuQmCC',
                option:{},
                onclick:function() {
                  let signTime = new Date().getTime()
                  _this.$store.commit('nowsign', signTime)
                  let urlData =  '?date='+_this.datevalue1.date + ' ' + _this.timevalue1.time + '&interval=8' + '&machineId=' + _this.tbmid + '&language='+ _this.$store.state.lang + '&sign='+_this.$store.state.sign + '&auth_Code='+_this.$store.state.authCode+'&sign_time='+signTime +'&route='+_this.$store.state.newroute+'&factory_id='+_this.$store.state.factoryId
                  window.open('/url/selectproductivity/prediction/export' + urlData, '_blank')                 
                }
            }
          }
        },
        grid:{
          top:'15%'
        },
        dataZoom: {
            show: false,
            start: 0,
            end: 100
        },
        xAxis: [
            {
                type: 'category',//折线图
                axisLabel: {
                  rotate: -45,
                },
                boundaryGap: true,
                data:(function (){
                    let res = [];
                    res = _this.echartsXList;
                    return res;
                })()
            },
            {
                show: false,//柱状图
                type: 'category',
                boundaryGap: true,
                data:(function (){
                    let res = [];
                    res = _this.echartsXList;
                    return res;
                })()
                
            }
        ],
        yAxis: [
            {//左侧的Y轴
                type: 'value',
                scale: true,
                name: _this.$t('PF001.productivity'),
                min: 0,
                nameGap: 12,
                boundaryGap: [0.2, 0.2]
            },
            {//右侧的Y轴
                show: false,
                type: 'value',
                scale: true,
                name: _this.$t('PF001.productivity'),
                min: 0,
                nameGap: 10,
                boundaryGap: [0.2, 0.2]
            }
        ],
        series: [
            {
                name:_this.$t('PF001.actual'),//初始值（柱状图y轴值）
                type:'bar',
                yAxisIndex: 0,
                data:(function (){
                    let res = [];
                    res = _this.actualList;
                    return res;
                })()
            },
            {
                name:_this.$t('PF001.predicted'),//折线图y轴值
                type:'line',
                data:(function (){
                    let res = [];
                    res = _this.predictedList;
                    return res;
                })()
            }
        ]
        })//setOption
    }, 
    showstart(){//柱状折线图接口
      this.echartsXList = []
      this.downImg = false
      this.downExcel = false
      
      let _this = this
      this.axios({
        method:'post',
        url:'url/selectproductivity/prediction/data',
        params:{//参数
          date:_this.datevalue1.date +' '+ _this.timevalue1.time,//开始时间date
          interval:'8',// 预测几小时的
          machineId: _this.tbmid,//机器ID
          language:_this.$store.state.lang
        }
      }).then(function(res){

        _this.myecharts = false
        if(res.data.success === 'true'){
          _this.downImg = true
          _this.downExcel = true

          let resList = res.data.msg
          
          _this.predictedList=[]
          _this.actualList=[]
          resList.forEach(item => {
            _this.predictedList.push(item.predicted)
            _this.actualList.push(item.actual)
            _this.echartsXList.push(item.time.slice(19,24)+'-'+item.time.slice(45,50))
          });
        }else {
          _this.noData()
          _this.predictedList=[]
          _this.actualList=[]
        }
      }).then(function(){
        _this.initChart()
      })
    },
    datevaluechange(){
      if(this.datevalue === null || this.datevalue === ''){
          return
        }
      let y = this.datevalue.getFullYear();
      let yy = y//存一下初始状态，用来做判断
      let y1 = y
      let y2 = y
      let m = this.datevalue.getMonth()+1; 
      let mm = m //存一下初始状态，用来做判断
      let m1 = m
      let m2 = m
      if(m<10){
        m ='0'+ m
      }
      let d = this.datevalue.getDate(); 
      this.today = d
      let dd = d//存一下初始状态，用来做判断
      let d1 = d
      let d2 = d
      if(d<10){
        d ='0'+ d
      }
      if(this.timevalue1.hours<8){
        d1 = (dd-1)
      }else if(this.timevalue1.hours>=16){
        d2 = (dd+1)
      }
      if(d1<=0){//d1的值用每个月的1号测试
        if(mm===5||mm===7||mm===10||mm===12){
          d1 = 30
        }else if(mm === 3){
          d1 = 28
        }else{
          d1 = 31
        }
        m1 = mm-1
      }else if(d1<10){
        d1 ='0'+ d1
      }
      if(mm === 2){
        let Leap = ''+yy/4
        if(Leap.length>3){
          if(d2>28){
              d2 = 1
              m2 = (mm+1)
          }
        }else{
          if(d2>29){
              d2 = 1
              m2 = (mm+1)
          }
        }
        
      }else if(mm===4||mm===6||mm===9||mm===11){
        if(d2>30){
            d2 = 1
            m2 = (mm+1)
        }
      }else if(mm===1||mm===3||mm===5||mm===7||mm===8||mm===10||mm===12){
            if(d2>31){
            d2 = 1
            m2 = (mm+1)
        }
      }
        
      if(m1<1){
        m1 = m1+12
        y1 = y1-1
      }
      if(m1<10){
        m1 ='0'+ m1
      }
      if(m2>12){
        m2 = m2-12
        y2 = y2+1
      }
      if(m2<10){
        m2 ='0'+ m2
      }
      if(d2<10){
        d2 ='0'+ d2
      }
      this.datevalue1.dateStart = y1 +'-'+ m1 +'-'+ d1;
      this.datevalue1.dateEnd = y2 +'-'+ m2 +'-'+ d2;
      this.datevalue1.date = y +'-'+ m +'-'+ d;

    },
    searchstart(){//点击显示按钮
      this.myecharts = true //控制echarts图表的loading
      this.tips()
      this.initChart()
    },
    tips() {//判断 提示语的内容
        if(this.machineID.length === 0){
          this.$message.error(this.$t('AnalogValueAnalysis.equipment'));
          this.myecharts = false
        }else if(this.datevalue === '' || this.datevalue === null){
          this.$message.error(this.$t('AnalogValueAnalysis.pChoosedate'));
            this.myecharts = false
        }else if(this.timevalueS === '' || this.timevalueS === null){
          this.$message.error(this.$t('AnalogValueAnalysis.pChoosetime'));
            this.myecharts = false
        }else{
          this.importantbody = true
          this.showstart()
        }
    },
    noData(){//当没有数据时的提示语
      this.$message.error(this.$t('PF001.noData'));
    },
    kongdata(x){//日期输入框清空
      if(x === null){
          this.datevalue1.dateStart = ''
          this.datevalue1.dateEnd = ''
      }
    },
    kongtime(x){//时间输入框清空
      if(x === null){
          this.timevalue1.timeStart = ''
          this.timevalue1.timeEnd = ''
      }
    },
    nowTimeS(){//限制选择的时间范围
      let y = new Date().getFullYear()
      let m = new Date().getMonth()+1
      if(m<10){
          m ='0'+ m
        }
      let d = new Date().getDate()
      if(d<10){
          d ='0'+ d
        }
      let nowTime = y +'-'+ m +'-'+ d
      if(this.datevalue1.date===nowTime){
        let t = new Date()+''
        let nowTimeEnd = t.slice(16,21)
        return {
          start: '00:00',
          step: '01:00',
          end: nowTimeEnd
        }
      }else{
        return {
          start: '00:00',
          step: '01:00',
          end: '23:00'
        }
      }
    },
    timevalueSchange(){
      if(this.timevalueS === null || this.timevalueS === ''){
        return
      }
      let h = Number(this.timevalueS.slice(0,2))
      let h1 = (h-8)
      if(h1>=0){
        if(h1<10){
          h1 ='0'+ h1
        }
      }else{
        h1 = (24+h1)
      }
      let h2 = (h+8)
      if(h2<10){
        h2 ='0'+ h2
      }else if(h2>=24){
        h2 = '0'+ [-(24-h2)]
      }
      if(h<10){
        h = '0'+h
      }
      this.timevalue1.timeStart = h1 +':00:00 ~ ' ;
      this.timevalue1.timeEnd = h2 +':00:00' ;
      this.timevalue1.hours = h
      this.timevalue1.time = h +':00:00' ;//请求数据传的参数
    },
    correctionTime(){//当再次选择的日期为今天且时间超过现在时
      if(this.today === new Date().getDate() && this.timevalue1.hours > new Date().getHours()){
        this.timevalueS = new Date().getHours() +':00:00' ;
      }
    },
  }
}
</script>
<style scoped>
.PF001{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
  display:flex;
  align-items: center;
}
/* 我的样式 */
.my{
  height: 800px;
  width: 100%;
}
.mynavlist{
  width: 94%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0 15px 0;
}
.mynavlist .navlistleft{
  width: 100%;
  display: flex;
  flex-direction: row;
}
.mynavlist .navlistleft .searchnavdate{
  width: 150px;
  margin-right: 14px;
}
.mynavlist .navlistleft .searchnavtime{
  width: 150px;
}
.mynavlist .navlistleft .addEight{
  font-size: 14px;
  line-height: 40px;
  color: #666;
  margin-left: 14px;
}
.navlistright .searchstart{
  width: 95px;
}
.importantbody{
  width: 94%;
  height: 86%;
  padding: 27px 0 10px;
  background: #fff;
  margin: 0 auto;
  color: rgba(80, 80, 80, 1);
}
.importantbody .selectsort{
  text-align: center;
  line-height: 27px;
  font-size:18px;
  font-weight: 700;
  margin-bottom: 6px;
}
.importantbody .selecttime{
  text-align: center;
  line-height: 21px;
  font-size:14px;
  margin-bottom: 14px;
}
.importantbody .selecttime .blank{
  margin-left: 5px;
}
#myecharts{
    width: 796px;
    height: 600px;
    margin:0 auto;
    background: #efefef;
}
/* element-ui样式 */
.mynavlist .navlistleft .searchers .el-select .el-input #EventCode{
    width: 160px;
}
.searchnavdate .block .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 150px;
}
.searchnavtime .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 150px;
}
.noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
}
</style>

